/* Publish by EComposer at 2025-07-28 19:03:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-52gtuf4oxyo"]=  window.__ectimmers["ecom-52gtuf4oxyo"] || {};
if(!this.$el||!window.EComModal)return;const e=this.isLive;let i=this.$el.querySelectorAll("[ecom-modal]");i.length&&e&&new window.EComModal(i,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-52gtuf4oxyo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52gtuf4oxyo', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}